
// Mobile Cart Button Fix - Force show and populate button text
// Version: 2026-05-01

(function() {
  'use strict';
  
  function fixMobileCartButton() {
    console.log('[CART FIX] Running mobile cart button fix...');
    
    // Find all skeleton-loading elements
    const skeletonElements = document.querySelectorAll('.skeleton-loading');
    skeletonElements.forEach(el => {
      el.classList.remove('skeleton-loading');
    });
    console.log(`[CART FIX] Removed skeleton-loading from ${skeletonElements.length} elements`);
    
    // Find all hidden-on-load elements
    const hiddenElements = document.querySelectorAll('.hidden-on-load');
    hiddenElements.forEach(el => {
      el.classList.remove('hidden-on-load');
    });
    console.log(`[CART FIX] Removed hidden-on-load from ${hiddenElements.length} elements`);
    
    // Find the buy button and ensure it has text
    const buyButton = document.querySelector('.product_submit_button');
    if (buyButton) {
      const btnLabel = buyButton.querySelector('.btn-label');
      if (btnLabel && (!btnLabel.textContent || btnLabel.textContent.trim() === '')) {
        // Try to get text from data attribute or use default
        const buttonText = buyButton.getAttribute('data-add-to-cart-text') || 'IN DEN WARENKORB';
        btnLabel.textContent = buttonText;
        console.log('[CART FIX] Added button text:', buttonText);
      } else if (btnLabel) {
        console.log('[CART FIX] Button already has text:', btnLabel.textContent);
      }
      
      // Force visibility
      buyButton.style.visibility = 'visible';
      buyButton.style.opacity = '1';
      if (btnLabel) {
        btnLabel.style.visibility = 'visible';
        btnLabel.style.opacity = '1';
        btnLabel.style.display = 'inline';
      }
    } else {
      console.log('[CART FIX] Buy button not found');
    }
  }
  
  // Run fix on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixMobileCartButton);
  } else {
    fixMobileCartButton();
  }
  
  // Also run after a short delay to catch late-loaded content
  setTimeout(fixMobileCartButton, 500);
  setTimeout(fixMobileCartButton, 1000);
  setTimeout(fixMobileCartButton, 2000);
  
  console.log('[CART FIX] Mobile cart button fix script loaded');
})();
